module.exports = __webpack_public_path__ + "img/DownWear.50fe4437.png";